import { put, apply } from 'redux-saga/effects';
import ironLegacyClient from '@app/data/ironLegacyClient';
import { history } from '@app/router';

import {
  portfolioItemSuccess,
  portfolioItemFail,
} from '@app/redux/portfolios/actions';

export const onPortfolioItemRequest = function* onPortfolioItemRequest({
  payload,
}) {
  try {
    const result = yield apply(
      ironLegacyClient,
      ironLegacyClient.getPortfolioItem,
      [payload.chainId, payload.params, payload.marketName],
    );

    yield put(portfolioItemSuccess(result.body.PortfolioItem));
  } catch (err) {
    // @ts-expect-error
    yield put(portfolioItemFail(err.response.text));
    history.push('/404');
  }
};
